<template>
    <el-dialog
            class="dia-box"
            :append-to-body="true"
            title="提示"
            :visible.sync="dialogVisible"
            width="60%"
    >
        <div class="my-box">
            <div>
                <el-table :data="tableData" style="width: 100%" height="300px">
                    <el-table-column prop="createName" label="操作人" width="180"> </el-table-column>
                    <el-table-column prop="createTime" label="操作时间" width="180">
                        <template slot-scope="scope">
                            {{scope.row.createTime|formatTime}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="operation" label="操作内容"> </el-table-column>
                </el-table>
            </div>
            <!-- <div class="btns">
              <el-button size="medium" type="primary" @click="goBack">返回</el-button>
            </div> -->

        </div>

    </el-dialog>



</template>

<script>
    import { invoiceApi } from "@/modules/server-api/invoice";
    export default {
        data() {
            return {
                tableData:[],
                invoiceNo:'',
                dialogVisible:false,
            };
        },
        created(){

        },
        methods: {
            getData(invoiceNo){
                this.invoiceNo=invoiceNo;
                this.dialogVisible=true
                this.getLogData()

            },
            goBack(){
                this.$router.push('/modules/invoice/view')
            },
            getLogData(){
                let params={invoiceNo:this.invoiceNo}
                invoiceApi.operateLog(params).then(res=>{
                    if(res.succ==1){
                        console.log(res.result)
                        this.tableData=res.result
                    }
                })

            }

        },
    };
</script>

<style scoped lang="scss">
    .my-box{
        height: 100%;
        background: #fff;
        padding:10px 20px;
    }
    .btns{
        height: 50px;
        line-height: 50px;
        text-align: center;
        .el-button{
            width:100px;
        }
    }
    .dia-box /deep/.el-dialog__body{
        padding:0px 20px 20px!important;
    }
</style>
